import GroupBy from "../../../../../gd/manager/group-by/group-by-model"
import {FieldType} from "../../../../field-type"
import {Date_GroupingOptions} from "../@const"

// const debug = "DateGrouping_getGroupLabel"
const debug = false

export default function DateGrouping_getGroupLabel(groupBy: GroupBy) {

    debug && console.log(debug, 'render', groupBy.field?.type, groupBy)

    switch (groupBy.field?.type) {
        case FieldType.TASK_DEADLINE:
        case FieldType.TASK_START_DATE:
        case FieldType.TASK_END_DATE:
        case FieldType.TASK_SCHEDULE:
        case FieldType.TASK_MOMENT_CREATED:
        case FieldType.TASK_MOMENT_CLOSED:
        case FieldType.TASK_LATEST_ACTIVITY_MOMENT:
        case FieldType.DATE:                            // custom field
        case FieldType.TIME_REPORT_DATE:
            const selectedInterval = _.find(Date_GroupingOptions, option=>option.value === groupBy.params.interval)
            return '{0} ({1})'.f(groupBy.field?.label, selectedInterval?.label)

        default:
            return groupBy.field?.label
    }
}